import { render, staticRenderFns } from "./FacultyApplyLeave.vue?vue&type=template&id=1ea4dc16"
import script from "./FacultyApplyLeave.vue?vue&type=script&lang=js"
export * from "./FacultyApplyLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports